"use client";
import React, {useContext, useEffect, useState} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import RedeemRecordUI from "@/app/(redeem)/redeemRecord/RedeemRecordUI";
import SDialogHeader from "@/app/_components/SDialogHeader/SDialogHeader";
import ComBG from "@/app/_components/ComBG/ComBG";
import RedeemBottomInfo from "@/app/(redeem)/components/RedeemBottomInfo/RedeemBottomInfo";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";

/**
 * 函数组件版 RedeemFailDialog 的 Props
 */
interface RedeemRecordDialogProps extends SDialogProps {
    /** 额外参数 */
    // 可根据需要添加其他 Props，例如：errorMessage
}

/**
 * 函数组件版 RedeemFailDialog
 */
export const RedeemRecordDialogFC: React.FC<RedeemRecordDialogProps> = (props) => {
    const { fcKey, onClose } = props;
    const { closeDialog } = useDialogMethods(fcKey);
    // ========== 模拟生命周期（类似 class 的 initData / onInit / onEnter） ==========
    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========
    const onClickBack = () => {
        closeDialog();
        onClose?.();
    };

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            onClose={onClose}
            // closeButtonVisible={true}
        >
            <ComBG>
                <SDialogHeader
                    title="HISTORY RECORD"
                    onClickBack={onClickBack}
                />
                <ScrollableContainer>
                    {/*<div className={"header_panel"}></div>*/}
                    <RedeemRecordUI/>
                    <RedeemBottomInfo/>
                </ScrollableContainer>
            </ComBG>
        </SDialogFC>
    );
};
